export enum ContainerStatusShortCodeEnum{
    FullInTransit = "FIT",
    FullInTransitHub = "FITH",
    FullInHub = "HUBFULL",
    Unpack = "UPK",
    Pack = "PAK",
    ReadyForPickup = "RFP",
    MTInTransit = "MTIT",
    MTInTransitHub = "MTITH",
    MTInHub = "HUBMT",
    Dehired = "DHIR",
    Pending = "PND",
    Inbound = "INBD",
    Arrived = "ARVD",
    Discharged = "DSCRGD",
    Available = "AVLB",
    GateOut = "GO",
    Active = "ACTV",
    ShipAtWharf = "SAW",
    WaitingRail = "WRAIL",
    OnRail = "ONRAIL",
    Inland = "INLND",
    Cleared = "CLRD",
    Wharf = "WHRF",
    OnVessel = "VSSL",
    Departed = "DEPT",
    Missed = "MSSD",
    Hold = "HLD",
    Unknown = "UNKWN"
}